import {useCookies} from "react-cookie";
import React, {useEffect, useState} from "react";
import {Script} from "gatsby";

const MicrosoftClarity = () => {
  const [cookies] = useCookies();
  const [clarityConsent, setClarityConsent] = useState(true);

  useEffect(() => {
    const consent = cookies.cookie_consent?.performance || cookies.cookie_consent?.marketing;
    setClarityConsent(consent);
    if (consent && typeof (window as any)?.clarity === 'function') {
      (window as any).clarity('consent', consent);
    }
  }, [cookies]);

  return (
      <>
        {
          clarityConsent ?
              <>
                <Script type="text/javascript">{`
                  (function(c,l,a,r,i,t,y){
                      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                  })(window, document, "clarity", "script", "${process.env.GATSBY_MICROSOFT_CLARITY_TRACKING_ID || ''}");
                  window.clarity('consent');
                 `
                }
                </Script>
              </>
              :
              null
        }
      </>
  );
}

export default MicrosoftClarity;
